import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UtilityService } from './shared/utility.service';
import { ContractRemote } from '../models/contractRemote.model';
import { ClientURL,ClientURLResponse, ContractListenerURL, ContractListenerURLResponse } from '../models/clienturl.model'
import { Guid } from 'guid-typescript';

@Injectable()
export class ContractRemoteService {
  private baseUrl: string;
  private api: string = "api/ContractRemote";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Contract Session Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async getContractRemoteLogAsync(encryptedUser: string, contractSessionId: number): Promise<ContractRemote | void> {
    const a = await this.httpClient
      .get<ContractRemote>(`${this.baseUrl}/GetContractRemoteLog/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, encryptedUser, "ContractRemoteService", "getContractRemoteLogAsync"); });

    return a;
  }

  async createContractRemoteLogAsync(encryptedUser: string, contractRemote: ContractRemote): Promise<ContractRemote | void> {
    const a = await this.httpClient
      .post<ContractRemote>(`${this.baseUrl}`, contractRemote, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contractRemote, "", encryptedUser, "ContractRemoteService", "createContractRemoteLogAsync"); });

    return a;
    }

    async createClientURLAsync(encryptedUser: string, clienturl: ClientURL): Promise<ClientURLResponse | void> {
        const a = await this.httpClient.post<ClientURLResponse>(`${this.baseUrl}/ClientURL_Create`, clienturl, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, clienturl, "", encryptedUser, "ContractRemoteService", "createClientURLAsync"); });
        return a;
    }

    async getclientUrlAsync(encryptedUser: string, uniqueId: Guid): Promise<ClientURLResponse | void> {
        const a = await this.httpClient
            .get<ClientURLResponse>(`${this.baseUrl}/ClientURL_Get/${uniqueId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "uniqueId - " + uniqueId, encryptedUser, "ContractRemoteService", "getclientUrlAsync"); });

        return a;
    }

    async createContractListenerAsync(encryptedUser: string, contractListenerURL: ContractListenerURL): Promise<ContractListenerURLResponse | void> {
        const a = await this.httpClient.post<ContractListenerURLResponse>(`${this.baseUrl}/ContractListener_Create`, contractListenerURL, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contractListenerURL, "", encryptedUser, "ContractRemoteService", "createContractListenerAsync"); });
        return a;
    }

    async getclientRemoteURLAsync(encryptedUser: string, contactId: number): Promise<ContractListenerURLResponse | void> {
        const a = await this.httpClient
            .get<ContractListenerURLResponse>(`${this.baseUrl}/ContractListener_Get/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contactId - " + contactId, encryptedUser, "ContractRemoteService", "getclientRemoteURLAsync"); });

        return a;
    }
}
